export const CARD_STATUS = {
	toActivate: 'toActivate',
	requested: 'requested',
	ordered: 'ordered',
	produced: 'produced',
	frozen: 'frozen',
	faulty: 'faulty',
	active: 'active',
};
